import clsx from 'clsx'
import { Select } from 'antd'

import { Icon } from '@iconify/react'

import './index.css'

const { Option } = Select

export default function TaskItemSelector({
    placeholder = 'Select a Sprint',
    options = [],
    disabled = false,
    value,
    onChange,
    isBugType = false,
    customClass = '',
    renderOption,
}) {
    return (
        <Select
            value={value}
            placeholder={placeholder}
            className={clsx('task-item-select', customClass)}
            variant="borderless"
            onChange={onChange}
            allowClear={false}
            disabled={disabled || isBugType}
            optionLabelProp="label"
            classNames={{
                popup: {
                    root: 'task-item-dropdown',
                },
            }}
            suffixIcon={<Icon icon="iconamoon:arrow-down-2-light" />}
        >
            {options?.map((opt) => {
                const isSelected = value === opt.value

                return (
                    <Option key={opt.value} value={opt.value} label={opt.label}>
                        <div className="task-item-option-wrapper">
                            <Icon
                                icon="ic:round-check"
                                height={18}
                                width={18}
                                className={`task-item-icon ${
                                    isSelected ? 'show' : 'hide'
                                }`}
                            />

                            {renderOption ? (
                                renderOption(opt)
                            ) : (
                                <span className="task-item-option">
                                    {opt.label}
                                </span>
                            )}
                        </div>
                    </Option>
                )
            })}
        </Select>
    )
}
